export function connectToQuickBooks(companyId) {
  window.location.replace(`${process.env.REACT_APP_QUICKBOOKS_CONNECT_URL}?companyId=${companyId}&redirect=${window.location}`);
}

export function connectToXero(companyId) {
  window.location.replace(`${process.env.REACT_APP_XERO_CONNECT_URL}?companyId=${companyId}&redirect=${window.location}`);
}
